import React from "react";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import { Avatar, Badge, Box, Stack, TableCell, TableRow, Typography } from "@mui/material";
import Label from "../../label/Label";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import { colors, fonts } from "../../../utility/types/constant";
interface ViewAndSearchAddRequestSendOutTableProps {
  profileImage: string;
  fullName: string;
  email: string;
  status: any;
  sendDay: string;
  isNew: boolean;
}

const ViewAndSearchAddRequestSendOutTable = (
  props: ViewAndSearchAddRequestSendOutTableProps
) => {
  const { profileImage, fullName, email, status, sendDay, isNew } = props;

  return (
    <TableRow
      hover
      tabIndex={-1}
      role="checkbox"
      sx={{ "&:hover": { bgcolor: alpha(colors.primary, 0.03) } }}
    >
      {/* Avatar */}
      <TableCell sx={{ pl: 2, width: 60 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Avatar
            alt={fullName}
            src={profileImage}
            sx={{ width: 36, height: 36, fontSize: "0.9rem" }}
          >
            {fullName.charAt(0)}
          </Avatar>
          {isNew && <NewTableRowData />}
        </Stack>
      </TableCell>

      {/* Full Name */}
      <TableCell>
        <Typography
          sx={{
            fontFamily: fonts.montserrat,
            fontWeight: 700,
            fontSize: "0.82rem",
            color: colors.primary,
          }}
        >
          {fullName}
        </Typography>
      </TableCell>

      {/* Email */}
      <TableCell>
        <Typography
          sx={{
            fontFamily: fonts.montserrat,
            fontSize: "0.8rem",
            color: colors.darkGrey,
          }}
        >
          {email}
        </Typography>
      </TableCell>

      {/* Status */}
      <TableCell>
        <Label
          color={
            (status === "Rejected" && "error") ||
            (status === "Pending" && "warning") ||
            (status === "Accepted" && "success") ||
            (status === "Approved" && "success")
          }
        >
          {status}
        </Label>
      </TableCell>

      {/* Sent On */}
      <TableCell>
        <Typography
          sx={{
            fontFamily: fonts.montserrat,
            fontSize: "0.78rem",
            color: colors.darkGrey,
          }}
        >
          {sendDay}
        </Typography>
      </TableCell>
    </TableRow>
  );
};

ViewAndSearchAddRequestSendOutTable.propTypes = {
  profileImage: PropTypes.string,
  fullName: PropTypes.string,
  email: PropTypes.string,
  status: PropTypes.any,
  sendDay: PropTypes.string,
  isNew: PropTypes.bool,
};

export default ViewAndSearchAddRequestSendOutTable;

export function NewTableRowData() {
  return (
    <Badge
      overlap="circular"
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      badgeContent={
        <NewReleasesIcon
          sx={{
            color: colors.lightGreen,
          }}
        />
      }
    >
      <span />
    </Badge>
  );
}
